const matchAnyUrlPattern = (url: string, patternUrls: string[] | undefined): boolean => {
    if (!patternUrls || patternUrls.length === 0) return false;

    const normalizePath = (path: string): string[] => {
        return path
            .replace(/^\/+|\/+$/g, '')
            .split('/')
            .filter((segment) => segment.length > 0);
    };

    const urlSegments = normalizePath(url);

    for (let i = 0; i < patternUrls.length; i++) {
        const patternSegments = normalizePath(patternUrls[i]);

        if (urlSegments.length !== patternSegments.length) {
            continue;
        }

        let patternFits = true;
        for (let j = 0; j < patternSegments.length; j++) {
            const patternSegment = patternSegments[j];
            const urlSegment = urlSegments[j];

            //Skip dynamic segments
            if (patternSegment.startsWith(':')) {
                continue;
            }

            //Compare dynamic segments
            if (patternSegment !== urlSegment) {
                patternFits = false;
                break;
            }
        }

        if (patternFits) return true;
    }

    return false;
};

export default matchAnyUrlPattern;
